/**
 * @flow
 * @relayHash 74fc09d568e30ec2be91279204264cc4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MarkInactiveContractorInput = {|
  id: string,
  isActive: boolean,
  clientMutationId?: ?string,
|};
export type MarkInactiveContractorMutationVariables = {|
  input: MarkInactiveContractorInput
|};
export type MarkInactiveContractorMutationResponse = {|
  +markInactiveContractor: ?{|
    +updatedContractor: ?{|
      +isActive: ?boolean
    |}
  |}
|};
export type MarkInactiveContractorMutation = {|
  variables: MarkInactiveContractorMutationVariables,
  response: MarkInactiveContractorMutationResponse,
|};
*/


/*
mutation MarkInactiveContractorMutation(
  $input: MarkInactiveContractorInput!
) {
  markInactiveContractor(input: $input) {
    updatedContractor {
      isActive
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "MarkInactiveContractorInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isActive",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MarkInactiveContractorMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "markInactiveContractor",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkInactiveContractorPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedContractor",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorNode",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MarkInactiveContractorMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "markInactiveContractor",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkInactiveContractorPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedContractor",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "MarkInactiveContractorMutation",
    "id": null,
    "text": "mutation MarkInactiveContractorMutation(\n  $input: MarkInactiveContractorInput!\n) {\n  markInactiveContractor(input: $input) {\n    updatedContractor {\n      isActive\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9c1e159e86acf9465db888f2d920a67a';
module.exports = node;
